define(function (require) {

    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpMessagingEngagementHistoryTransformationHelper = require('web-agent-adapters/lpMessagingEngagementHistoryTransformationHelper');
    var BASE = require('web-agent-adapters/BaseAdapter');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var webAgentUtils = require('web-agent-utils/WebAgentUtils');
    var transformationHelper = lpMessagingEngagementHistoryTransformationHelper;
    var lpSdeDataHandler = require('web-agent-assets-js/lpSdeDataHandler');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');

    var SEARCH_TYPES = {
        All: 'SearchEngagements',
        ByAgent: 'SearchEngagementsByAgent',
        ByConsumer: 'SearchEngagementsByConsumer',
        ByConversation:'SearchEngagementsByConversation',
        photoSharingGetUrl:'photoSharingGetUrl'
    };
    var SUPPORTED_AUTH_SDES = { personalInfo: 'personalInfo', customerInfo: 'customerInfo'};
    var CONTENT_BLOCKS = getContentBlocks();

    var ORDERING = {
        asc: 'asc',
        desc: 'desc'
    };

    var sdeTypeNames = {
        CART_STATUS: 'CartStatusEvent',
        SERVICE_ACTIVITY: 'ServiceActivityEvent',
        CUSTOMER_INFO: 'CustomerInfoEvent',
        MARKETING_CAMPAIGN_INFO: 'MarketingCampaignInfoEvent',
        PERSONAL_INFO: 'PersonalInfoEvent',
        PURCHASE: 'PurchaseEvent',
        VIEWED_PRODUCT: 'ViewedProductEvent',
        VEHICLE_OF_INTEREST: 'VoiEvent',
        VISITOR_ERROR: 'VisitorErrorEvent',
        LEAD: 'LeadEvent',
        SEARCH_CONTENT: 'SearchContentEvent'
    };

    var CAPPING_SETTINGS = {
        SINGLE: {
            ConversationSummaryEvent: { quantity: 1, order: ORDERING.desc },
            CartStatusEvent: { quantity: 1, order: ORDERING.desc },
            ServiceActivityEvent: { quantity: 1, order: ORDERING.desc },
            CustomerInfoEvent: { quantity: 1, order: ORDERING.desc },
            MarketingCampaignInfoEvent: { quantity: 1, order: ORDERING.desc },
            PersonalInfoEvent: { quantity: 1, order: ORDERING.desc },
            PurchaseEvent: { quantity: 50, order: ORDERING.desc },
            ViewedProductEvent: { quantity: 50, order: ORDERING.desc },
            VisitorErrorEvent: { quantity: 20, order: ORDERING.desc },
            LeadEvent: { quantity: 50, order: ORDERING.desc },
            SearchContentEvent: { quantity: 30, order: ORDERING.desc }
        },
        LIST: {
            PersonalInfoEvent: { quantity: 1, order: ORDERING.desc },
            CustomerInfoEvent: { quantity: 1, order: ORDERING.desc },
        }
    };

    var CAPPING_CONFIGURATION = {
        SINGLE: parseSdeCappingSettings(CAPPING_SETTINGS.SINGLE),
        LIST: parseSdeCappingSettings(CAPPING_SETTINGS.LIST)
     };

    var DIALOG_TYPES = {
        MAIN: "MAIN",
        POST_SURVEY: "POST_SURVEY",
        AGENT: "AGENT",
        OTHER: "OTHER"
    };

    var CHANNEL_TYPES = {
        MESSAGING: 'MESSAGING',
        LIVE_CHAT: 'LIVE_CHAT'
    };

    var CONVERSATION_STATES = {
        OPEN: 'OPEN',
        CLOSE: 'CLOSE'
    };

    var lpMessagingEngagementHistoryTableAdapter = BASE.extend(function (options) {
    });

    lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES = SEARCH_TYPES;
    lpMessagingEngagementHistoryTableAdapter.SUPPORTED_AUTH_SDES = SUPPORTED_AUTH_SDES;
    lpMessagingEngagementHistoryTableAdapter.CAPPING_CONFIGURATION = CAPPING_CONFIGURATION;
    lpMessagingEngagementHistoryTableAdapter.CONTENT_BLOCKS = CONTENT_BLOCKS;

    lpMessagingEngagementHistoryTableAdapter.prototype.applicationType = "lpMessagingEngagementHistoryTableAdapter";
    lpMessagingEngagementHistoryTableAdapter.prototype.CAPPING_CONFIGURATION = CAPPING_CONFIGURATION;
    lpMessagingEngagementHistoryTableAdapter.prototype.CONTENT_BLOCKS = CONTENT_BLOCKS;

    function getContentBlocks() {
        var contentBlocks = {
            BASE: ["campaign", "messageRecords", "agentParticipants", "agentParticipantsLeave", "agentParticipantsActive", "consumerParticipants", "transfers", "messageScores", "messageStatuses", "conversationSurveys", "sdes", "summary", "responseTime"],
            ALL: ["campaign", "messageRecords", "agentParticipants", "agentParticipantsLeave", "agentParticipantsActive", "consumerParticipants", "transfers", "interactions", "messageScores", "messageStatuses", "conversationSurveys", "coBrowseSessions", "sdes", "unAuthSdes", "summary", "monitoring", "responseTime"],
            LIST: ["campaign", "messageRecords", "agentParticipants", "agentParticipantsLeave", "agentParticipantsActive", "consumerParticipants", "transfers", "messageScores", "messageStatuses", "conversationSurveys", "sdes", "responseTime"],
            MONITORING: ["unAuthSdes", "monitoring"]
        };
        if (!!agentLEManager.getFeatureProperty("Common.Messaging_Survey")) {
            contentBlocks.BASE.push('dialogs');
            contentBlocks.ALL.push('dialogs');
            contentBlocks.LIST.push('dialogs');
        }
        return contentBlocks;
    }

    lpMessagingEngagementHistoryTableAdapter.prototype.searchEngagements = function (request) {
        var agentData = this.model.get('agent');
        var searchType = request.searchType;
        var isSingleConversationSearch = !!(request.data && request.data.conversationId);
        var decoratedRequestObject = decorateRequestObject(request, agentData, isSingleConversationSearch);
        return this.service.searchEngagements(decoratedRequestObject, searchType);
    };

    lpMessagingEngagementHistoryTableAdapter.prototype.photoSharingGetUrl = function (request) {
        return this.service.photoSharingGetUrl(request);
    };

    function parseSdeCappingSettings(settings) {
        var parsed = [];
        for (var sde in settings) {
            if (settings[sde]) {
                var sdeSetting = settings[sde].quantity ? ':' + settings[sde].quantity : '';
                sdeSetting += settings[sde].order ? ':' + settings[sde].order : '';
                if (sdeSetting) {
                    parsed.push(sde + sdeSetting);
                }
            }
        }
        return parsed.join(',');
    }

    function decorateRequestObject(request, agentData, isSingleConversationSearch) {
        var successHandler = request.success;
        var errorHandler = request.error;

        if (_.isFunction(successHandler)) {
            request.success = function (response) {
                var transformedData = transformToListDataObject(agentData, response, isSingleConversationSearch);
                if (transformedData) {
                    successHandler(transformedData);
                } else if (_.isFunction(errorHandler)) {
                    errorHandler({
                        error: 'transformation failed, invalid data.'
                    });
                }
            };
        }
        return request;
    }

    function transformToListDataObject(agentData, response, isSingleConversationSearch) {
        if (response && response.body && response.body._metadata && response.body.conversationHistoryRecords) {
            var count = response.body._metadata.count;
            var data = getData(response.body.conversationHistoryRecords);
            return {
                count: count,
                data: data
            };
        }

        // Converting the records to chat model.
        function getData(conversationHistoryRecords) {
            return _.map(conversationHistoryRecords, function (item) {
                return getSingleRecordModel(item);
            });
        }

        function getSingleRecordModel(recordData) {
            transformationHelper.transformConsumerNameBySDEs(recordData);
            transformationHelper.normalizeAgentsParticipantsList(recordData);

            var consumer = transformationHelper.getConsumerObject(recordData);
            var brandId = recordData.info.brandId;
            var isInQueue = recordData.info.latestQueueState === 'IN_QUEUE';
            var suggestedAgent = isInQueue && transformationHelper.getSuggestedAgent(recordData);
            var dialogs = getDialogs(recordData);
            var chatTranscript = transformationHelper.getTranscript(recordData, dialogs);
            var lastResponseTime = recordData.responseTime && recordData.responseTime.latestEffectiveResponseDueTime;
            var status = recordData.info && recordData.info.status;
            var isOverdue = recordData.responseTime && MessagingUtils.isConversationOverdue(lastResponseTime, status);
            var assignedAgent = !isInQueue && transformationHelper.getAssignedAgent(recordData);
                /* the isPartial from the service is not reliable, it's can return true when retriving
                   a single conversation object.
                */
            var isPartial = !isSingleConversationSearch;
            lpTag.WebAgent.logicController.addIndicationToStartAndEndDialogLines(chatTranscript, dialogs);
            var mainDialog = getMainDialog(dialogs);

            // Monitoring Visitor Info
            function getVisitorInfo(data) {
                return data && {
                    country: data.country,
                    countryCode: data.countryCode,
                    geoState: data.state,
                    geoCity: data.city,
                    isp: data.isp,
                    organization: data.org,
                    deviceFamily: data.device,
                    browser: data.browser,
                    ipv4: data.ipAddress,
                    operatingSystem: data.operatingSystem,
                    externalReferrer: data.conversationStartPage,
                    externalReferrerTitle: data.conversationStartPageTitle
                };
            }

            /**
             * manual capping for the unauthSdes request
             */
            function trimSdesByCapping(sdes) {
                if (!sdes) {
                    return sdes;
                }
                var sortedSdes = _.reduce(sdes, function (result, value) {
                    var sdeType = value && value.sdeType;
                    (result[sdeType] || (result[sdeType] = [])).push(value);
                    return result;
                }, {});
                _.each(sortedSdes,function (el, key) {
                    var cappingSettings = CAPPING_SETTINGS.SINGLE[sdeTypeNames[key]];
                    var cappingQuantity = cappingSettings && cappingSettings.quantity;
                    if (cappingQuantity && el.length > cappingQuantity) {
                        el.splice(cappingQuantity);
                    }
                });
                var trimmedSdes = _.reduce(sortedSdes, function (result, value) {
                    return result.concat(value);
                }, []);
                return trimmedSdes;
            }

            /**
             * Return a list of processed SDE's.
             */
            function getAllSDEs() {
                // Extracting the two chunks of SDE's (Auth + UnAuth)
                var authSDEs = (recordData && recordData.sdes && recordData.sdes.events) || [];
                var unauthSDEs = (recordData && recordData.unAuthSdes && recordData.unAuthSdes.events) || [];

                // Tagging the Auth SDE with Auth flag for processing.
                _.each(authSDEs, function(event) {
                    event.isAuthenticated = true;
                    var authenticatedData = _.find(Object.keys(event), function (el) { return SUPPORTED_AUTH_SDES[el] === el; });
                    if (authenticatedData) {
                        event[authenticatedData].isAuthenticated = true;
                    }
                });

                // manual capping for the engagement history response
                // unauthSDEs = trimSdesByCapping(unauthSDEs);

                // Marging all SDE's.
                var allSDEEvents = [].concat(authSDEs, unauthSDEs);

                // Sending the SDE's to Transformation and return the results.
                return lpSdeDataHandler.getProcessedSDEsEvents(allSDEEvents);
            }
            var chatInfo = getChatInfoBlock(recordData);

            var chatData = {
                chatInfo: chatInfo,
                visitorInfo: _.assign(
                    {},
                    getVisitorInfoBlock(recordData),
                    getVisitorInfo(recordData && recordData.monitoring),
                    getAllSDEs()
                ),
                oldChatLine: {
                    lines:  isPartial ? [] : chatTranscript
                },
                isPartial: isPartial,
                isDeleted: isConversationDeleted()
            };

            if (assignedAgent) {
                chatData.agentInfo = getAgentInfoBlock(assignedAgent);
            } else if (suggestedAgent) {
                chatData.suggestedAgentInfo = getAgentInfoBlock(suggestedAgent);
            }

            var metaData = {
                agentNames: getAgentNames(),
                agentGroups: getAgentGroups(),
                skills: getSkills(),
                latestAgentId: getLatestAgentId(),
                isPartial: isPartial
            };

            return {
                chatData: chatData,
                metaData: metaData
            };

            function getAgentInfoBlock(assignedAgent) {
                var agentInfoObj = {
                    agentId: assignedAgent.agentId,
                    agentName: transformationHelper.getAgentName(assignedAgent),
                    agentGroupId: assignedAgent && assignedAgent.agentGroupId,
                    agentTyping: false,
                    loggedInAgentUnreadCount: 0,
                    messagingUserId: brandId + '.' + assignedAgent.agentId,
                    agentGroupName: assignedAgent && assignedAgent.agentGroupName,
                    agentDeleted: !!assignedAgent.agentDeleted,
                    agentState: assignedAgent && (assignedAgent.agentState || lpTag.AMSStatics.assignedAgentState.ACTIVE)
                };

                return agentInfoObj;
            }

            function getChatInfoBlock(data) {
                var info = data.info;
                var campaign = data.campaign;
                var responseTime = data.responseTime;
                var activeDialog = getActiveDialog(dialogs);
                var lastMainDialogMessage = getDialogLastLine(mainDialog); //last main dialog message. may not be available or most updated
                var lastSkillId = "" + info.latestSkillId;
                var convState = info.fullDialogStatus || info.status;
                var originContext = transformationHelper.getOriginContext(info);
                var featuresAndIntegration = MessagingUtils.getFeaturesAndIntegrationFromContext(originContext);


                return {
                    CSATRate: info.csatRate,
                    agentNote: (data.summary && data.summary.text) || '',
                    badges: {
                        first_time: info.firstConversation,
                        in_queue: isInQueue,
                        urgent: false, // History not support SLA.
                        overdue: isOverdue,
                        in_survey: activeDialog && activeDialog.dialogType === DIALOG_TYPES.POST_SURVEY,
                        no_active_dialog: CONVERSATION_STATES.OPEN === convState && !activeDialog
                    },
                    chatId: info.conversationId,
                    engagementType:
                        lpTag.WebAgent.logicController.engagementTypes
                            .asyncMessaging,
                    events: {
                        event:  isPartial ? [] : chatTranscript
                    },
                    manualETTR: -1,
                    messagingState: convState,
                    newUmsApiActive: typeof info.fullDialogStatus !== "undefined",
                    closeReason: info.closeReason,
                    mainDialogCloseReason: mainDialog && mainDialog.closedBy,
                    skillIds: lastSkillId,
                    skillName: info.latestSkillName,
                    dialogs: dialogs,
                    activeDialogId: activeDialog && activeDialog.dialogId,
                    mcs: info.mcs,
                    alertedMCS: info.alertedMCS,
                    startTime: info.startTimeL,
                    state: lpTag.WebAgent.logicController.conversationStateToChatState(convState),
                    lastMainDialogMessage: lastMainDialogMessage,
                    endTime: info.endTimeL,
                    duration: info.duration,
                    latestAgentId: info.latestAgentId,
                    campaignId: campaign && _.parseInt(campaign.campaignId) || undefined,
                    engagementId: campaign && _.parseInt(campaign.campaignEngagementId) || undefined,
                    mainDialogParticipantsHash: getParticipantsHash({ mainDialog: mainDialog }),
                    allParticipantsHash: getParticipantsHash(dialogs),
                    responseTime: responseTime && _.isObject(responseTime) && {
                        configuredResponseTime: responseTime.configuredResponseTime,
                        latestEffectiveResponseDueTime: responseTime.latestEffectiveResponseDueTime,
                        slaTexts: getTextualSLA(responseTime.latestEffectiveResponseDueTime, info.status)
                    },
                    originContext: originContext,
                    features: featuresAndIntegration.features,
                    integration: featuresAndIntegration.integration,
                    channelSource: MessagingUtils.calculateChannelSource(originContext)
                };
            }

            function getTextualSLA(timeStamp, status) {
                var timeStampForSLA = status === "CLOSE" ? -1 : timeStamp;
                // server timediff 0 is passed
                return lpTag.WebAgent.logicController.getSLATextFromTimestamp(timeStampForSLA, 0);
            }

            function getParticipantsHash(dialogs){
                var hash = '';
                _.each(dialogs, function (dialog) {
                    if (dialog) {
                        hash += dialog.dialogId + ':';
                        _.each(dialog.participantsDetails, function (userVal, userKey) {
                            hash += userKey + '*' + userVal.role + ';';
                        });
                        _.each(dialog.suggestedParticipantsDetails, function (userVal, userKey) {
                            hash += userKey + '*' + userVal.role + ';';
                        });
                    }
                });

                return hash;
            }

            function getMainDialog(dialogs) {
                return _.find(dialogs, function(dialog) { return dialog.dialogType === DIALOG_TYPES.MAIN; });
            }

            function getActiveDialog(dialogs) {
                return _.find(dialogs, function(dialog) { return dialog.state === CONVERSATION_STATES.OPEN; });
            }

            function getDialogLastLine(dialog) {
                var transcriptLines = [];
                var dialogId = dialog && dialog.dialogId;
                if (dialogId) {
                    transcriptLines = _.filter(chatTranscript, function(line) { return line.dialogId === dialogId; });
                }
                return _.last(transcriptLines);
            }

            function getDialogs(data) {
                var conversationDialogs = {};
                if (!data.dialogs || !data.dialogs.length) {
                    var firstMessage = _.head(chatTranscript);
                    var lastMessage = _.last(chatTranscript);
                    conversationDialogs[data.info.conversationId] = {
                        participantsDetails: recordData.agentParticipants[data.info.conversationId] || {},
                        dialogId: data.info.conversationId,
                        state: data.info.status,
                        dialogType: DIALOG_TYPES.MAIN,
                        channelType: CHANNEL_TYPES.MESSAGING,
                        startTs: firstMessage && firstMessage.time,
                        endTs: lastMessage && lastMessage.time,
                        closedBy: data.info.closeReason,
                        suggestedParticipantDetails: {}
                    };
                    /// remove from participant details list if exists
                    if (suggestedAgent) {
                        conversationDialogs[data.info.conversationId].suggestedParticipantDetails[suggestedAgent.agentId] = suggestedAgent;
                        delete conversationDialogs[data.info.conversationId].participantsDetails[suggestedAgent.agentId];
                    }
                }
                else {
                    _.each(data.dialogs, function (dialog) {
                        conversationDialogs[dialog.dialogId] = {
                            participantsDetails: recordData.agentParticipants[dialog.dialogId] || {},
                            dialogId: dialog.dialogId,
                            state: dialog.status,
                            dialogType: dialog.dialogType,
                            channelType: dialog.dialogChannelType,
                            startTs: dialog.startTimeL,
                            endTs: dialog.endTimeL,
                            closedBy: dialog.closeReason || data.info.closeReason, // fallback for rollback case
                            suggestedParticipantDetails: {}
                        };
                        if (suggestedAgent) {
                            conversationDialogs[dialog.dialogId].suggestedParticipantDetails[suggestedAgent.agentId] = suggestedAgent;
                            delete conversationDialogs[dialog.dialogId].participantsDetails[suggestedAgent.agentId];
                        }
                    });
                }
                return conversationDialogs;
            }

            function getVisitorInfoBlock(data) {
                var agentId = brandId + '.' + (assignedAgent && assignedAgent.agentId);
                var isAcceptedEngagement = agentId === agentData.messagingUserId;

                var _info = data.info || {};
                var _campaignData = data.campaign;

                return _.assign({
                    shark: false,
                    acceptedEngagement: isAcceptedEngagement,
                    spectatedEngagement: !isAcceptedEngagement,
                    visitorId: consumer && consumer.participantId,
                    // description: consumer && consumer.participantId,
                    visitorName: consumer && consumer.consumerName,
                    sharkVisitorId: _info.visitorId,
                    imgUrl: consumer && consumer.avatarURL,
                    avatarUrl: consumer && consumer.avatarURL,
                    CSATPercentText: _info.csatRate,
                    skill: _info.latestSkillName,
                    startTime: _info.startTimeL,
                    engagementStartTime: _info.startTimeL,
                    // channelSource: _info.source, // recordData.info.source === 'SHARK' <- what is the effect of this??!?
                    deviceFamily: _info.device,
                    conversationId: _info.conversationId
                }, transformationHelper.transformObjectToCampaignInfo(_campaignData));
            }

            function getAgentNames() {
                var agentNamesArr = [];
                agentNamesArr.push({
                    name: recordData.info.latestAgentFullName,
                    id: recordData.info.latestAgentId || -1
                });

                // look only in main dialog participants
                _.each(mainDialog && mainDialog.participantsDetails, function (item) {
                    if(item.role === "ASSIGNED_AGENT") {
                        agentNamesArr.push({
                            name: item.agentDeleted ? agentLEManager.translateLE("LEWebAgent.agent_deleted_indication") + ' ' + item.agentFullName : item.agentFullName,
                            id: item.agentId
                        });
                    }
                });

                agentNamesArr = _.uniq(agentNamesArr, "id");
                if(assignedAgent){
                    agentNamesArr.splice(0,1);
                }
                return agentNamesArr;
            }

            function getAgentGroups() {
                var agentGroupsArr = [];
                agentGroupsArr.push({
                    name: recordData.info.latestAgentGroupName,
                    id: recordData.info.latestAgentGroupId
                });

                // look only in main dialog participants
                _.each(mainDialog && mainDialog.participantsDetails, function (item) {
                    if(item.role === "ASSIGNED_AGENT") {
                        agentGroupsArr.push({
                            name: item.agentGroupName,
                            id: item.agentGroupId
                        });
                    }
                });

                agentGroupsArr = _.uniq(agentGroupsArr, "id");
                if(assignedAgent){
                    agentGroupsArr.splice(0,1);
                }
                return agentGroupsArr;
            }

            function getSkills() {
                var skillsArr = [];
                skillsArr.push({
                    name: recordData.info.latestSkillName,
                    id: recordData.info.latestSkillId
                });

                _.each(recordData.transfers, function(item) {
                    if (item.reason === 'Skill' || item.reason === 'Agent') {
                        if (item.sourceSkillId !== -1) {
                            skillsArr.push({
                                name: item.sourceSkillName,
                                id: item.sourceSkillId
                            });
                        }
                        if (item.targetSkillId !== -1) {
                            skillsArr.push({
                                name: item.targetSkillName,
                                id: item.targetSkillId
                            });
                        }
                    }
                });

                skillsArr = _.uniq(skillsArr, 'id');
                skillsArr.splice(0, 1);
                return skillsArr;
            }

            function getLatestAgentId() {
                return (
                    recordData &&
                    recordData.info &&
                    recordData.info.latestAgentId
                );
            }

            /**
             * Checks if conversation is marked as deleted
             * A deleted conversation is a conversation that is old than the deletion time period configuration (in days)
             * @param {Object} chatInfo conversation info
             * @returns {Boolean=}
             */
            function isConversationDeleted() {
                if (recordData && recordData.info) {
                    var convEndTime = recordData.info.endTimeL;
                    var duartionForDeletionInDays = webAgentUtils.getDataRetentionTime();
                    if (_.isNumber(convEndTime) && convEndTime > -1) {
                        var now = new Date();
                        var convEnd = new Date(convEndTime);
                        var durationInDays = Math.floor((now - convEnd) / (1000 * 60 * 60 * 24));
                        return durationInDays > duartionForDeletionInDays;
                    }
                }
            }
        }
    }

    return lpMessagingEngagementHistoryTableAdapter;

});
